import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { play as enginePlay, setSoundEnabled, startHum as engineStartHum, stopHum } from "@/lib/sounds";
import { SITE } from "@/data/content";

const SoundCtx = createContext(null);

export function SoundProvider({ children }) {
  const [enabled, setEnabled] = useState(() => {
    try {
      const s = localStorage.getItem("fridge-sound");
      return s === null ? SITE.soundDefault : s === "1";
    } catch (e) {
      return SITE.soundDefault;
    }
  });
  const enabledRef = useRef(enabled);
  useEffect(() => {
    enabledRef.current = enabled;
    setSoundEnabled(enabled);
  }, [enabled]);

  const play = useCallback((name) => enginePlay(name), []);
  const toggle = useCallback(() => {
    setEnabled((e) => {
      const next = !e;
      try { localStorage.setItem("fridge-sound", next ? "1" : "0"); } catch (err) {}
      setSoundEnabled(next);
      if (next) enginePlay("pop");
      return next;
    });
  }, []);
  const startHum = useCallback(() => { if (enabledRef.current) engineStartHum(); }, []);
  const stopHumSafe = useCallback(() => stopHum(), []);

  return (
    <SoundCtx.Provider value={{ enabled, play, toggle, startHum, stopHum: stopHumSafe }}>
      {children}
    </SoundCtx.Provider>
  );
}

export function useSound() {
  return useContext(SoundCtx);
}